<template>
  <div>
    <button
      class="btn btn-wd btn-fill btn-info"
      @click="handleReport"
    >
      Gerar relatório de dados: {{eventLabel}}
    </button>
  </div>
</template>

<script>
  import swal from 'sweetalert2'
  import Couchdb from 'src/services/Couchdb'
  import blobUtils from 'blob-util'
  import downloadJs from 'downloadjs'
  import {mapActions} from 'vuex'

  export default {
    name: 'general-counter-report',

    data () {
      return {
        csv: '',
        limitator: ',',
        events: {},
        lamps: {},
        tickets: {},
        refrigerators: {},
        tags: [],
        headers: [
          `"Evento"`,
          `"Local do evento"`,
          `"Município"`,
          `"Estado do evento"`,
          `"Data do início do vento"`,
          `"Data do fim do evento"`,
          `"Quantidade de geladeira"`,
          `"Tickets gerados"`,
          `"Lâmpadas trocadas"`
        ]
      }
    },

    computed: {
      eventLabel () {
        return localStorage.getItem('eventLabel') || 'Ações'
      }
    },

    methods: {
      ...mapActions('tags', {
        fetchTags: 'fetchAll'
      }),

      handleReport () {
        swal({
          title: 'Informações',
          text: 'Estamos gerando o relatório. Por favor aguarde e não recarregue ou feche a página.',
          type: 'info',
          showConfirmButton: false,
          allowOutsideClick: false,
          onOpen: async () => {
            swal.showLoading()

            this.resetValues()
            await this.fetchData()
            this.createReport()
            this.download()

            swal.hideLoading()
            swal.close()
          }
        })
      },

      fetchData () {
        return new Promise(async resolve => {
          await this.fetchEvents()
          await this.fetchAmmounts()
          await this.fetchTags({limit: 999})
            .then(res => (this.tags = res.map(item => item.name.toUpperCase()).sort((a, b) => a.localeCompare(b))))
          resolve(true)
        })
      },

      fetchEvents () {
        return new Promise(resolve => {
          this.fetchPromiseView('events-by-id')
            .then((res) => {
              this.events = res.map(item => item.value)
                .reduce((accum, curr) => this.reduceObjectById(accum, curr), {})

              resolve(true)
            })
            .catch((err) => {
              console.log('Não foi possível consultar os eventos')
              err = null
              resolve(false)
            })
        })
      },

      async fetchAmmounts () {
        await this.fetchTicketsCount()
        await this.fetchLamps()
        await this.fetchRefrigerators()
      },

      fetchTicketsCount () {
        return new Promise(resolve => {
          this.fetchPromiseView('counter-events-tickets', true)
            .then(res => {
              this.tickets = res.reduce((acc, curr) => this.reduceObjectByKey(acc, curr), {})
              resolve(true)
            })
            .catch(err => {
              console.log('Ocorreu um erro ao coletar os tickets')
              console.log(err)
              resolve(false)
            })
        })
      },

      fetchLamps () {
        return new Promise(resolve => {
          this.fetchPromiseView('counter-events-lamps', true)
            .then(res => {
              this.lamps = res.reduce((acc, curr) => this.reduceObjectByKey(acc, curr), {})
              resolve(true)
            })
            .catch(err => {
              console.log('Ocorreu um erro ao coletar os tickets')
              console.log(err)
              resolve(false)
            })
        })
      },

      fetchRefrigerators () {
        return new Promise(resolve => {
          this.fetchPromiseView('counter-events-refrigerators', true)
            .then(res => {
              this.refrigerators = res.reduce((acc, curr) => this.reduceObjectByKey(acc, curr), {})
              resolve(true)
            })
            .catch(err => {
              console.log('Ocorreu um erro ao coletar os tickets')
              console.log(err)
              resolve(false)
            })
        })
      },

      fetchPromiseView (ddocView, reduce = false) {
        return new Promise(resolve => {
          Couchdb.viewQueries({
            connection: 'default',
            ddoc: ddocView,
            view: ddocView,
            queries: [{reduce, group: reduce}]
          })
            .then(res => {
              if (res[0].rows) resolve(res[0].rows)
              resolve(false)
            })
            .catch(err => {
              console.log(ddocView, err)
              resolve(false)
            })
        })
      },

      resetValues () {
        this.events = {}
      },

      reduceObjectById (accum, curr) {
        accum[curr._id] = curr
        return accum
      },

      reduceObjectByKey (accum, curr) {
        let key = curr.key
        accum[key] = curr.value
        return accum
      },

      createReport () {
        this.setHeaders()
        this.setRows()
        this.setGeneratedTime()
      },

      setHeaders () {
        this.csv = this.headers.concat(this.tags).join(this.limitator)
        this.csv += '\n'
      },

      setRows () {
        for (let idEvent in this.events) {
          this.setRow(this.events[idEvent])
        }
      },

      setRow (event) {
        this.csv += `"${event.reference}"${this.limitator}`
        this.csv += `"${event.place}"${this.limitator}`
        this.csv += `"${event.city}"${this.limitator}`
        this.csv += `"${event.status === 2 ? 'Finalizado' : 'Iniciado'}"${this.limitator}`
        this.csv += `"${this.$moment(event.startDate).format('L')} ${this.$moment(event.startDate).format('LTS')}"${this.limitator}`
        this.csv += `"${this.$moment(event.endDate).format('L')} ${this.$moment(event.endDate).format('LTS')}"${this.limitator}`
        this.csv += `${this.refrigerators[event._id] ? this.refrigerators[event._id] : 0}${this.limitator}`
        this.csv += `${this.tickets[event._id] ? this.tickets[event._id] : 0}${this.limitator}`
        this.csv += `${this.lamps[event._id] ? this.lamps[event._id] : 0}${this.limitator}`
        for (let tag of this.tags) {
          if (!event.hasOwnProperty('tags') || !event.tags.find(item => item.toUpperCase() === tag.toUpperCase())) {
            this.csv += ` ${this.limitator}`
            continue
          }
          console.log(event.tags, tag)
          this.csv += `X ${this.limitator}`
        }
        this.csv += '\n'
        return true
      },

      setGeneratedTime () {
        this.csv += '\n'
        this.csv += `"Relatório solicitado em", ${this.$moment(new Date()).format('LLL')}`
      },

      download () {
        let blob = blobUtils.createBlob([this.csv], {type: 'text/plain'})
        let now = this.$moment(new Date()).format('DD-MM-YYYY_HH-mm-ss')
        let filename = `Relatório_Contagens_Por_Eventos_${now}`
        downloadJs(blob, `${filename}.csv`)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Reports/GeneralCounterReport.vue